'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = require('./ExtendableError');

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Thrown when a function is called with an invalid mandatory parameter
 * @param {string} paramName
 */


var InvalidParamError = function (_ExtendableError) {
  (0, _inherits3["default"])(InvalidParamError, _ExtendableError);

  function InvalidParamError(paramName, paramValue, reason) {
    (0, _classCallCheck3["default"])(this, InvalidParamError);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (InvalidParamError.__proto__ || (0, _getPrototypeOf2["default"])(InvalidParamError)).call(this, 'invalid ' + paramName + (paramValue ? ' :: ' + paramValue : '') + (reason ? ' because ' + reason : '')));

    _this.paramName = paramName;
    _this.paramValue = paramValue;
    _this.reason = reason;
    return _this;
  }

  return InvalidParamError;
}(_ExtendableError3["default"]);

exports["default"] = InvalidParamError;